const MAILCHIMP_POST_JSON =
  'https://transfusionontario.us14.list-manage.com/subscribe/post-json?u=d83dcc6407dd979e501cb0e36&id=5aed315aea';

export const NEWSLETTER_HONEYPOT_FIELD = 'b_d83dcc6407dd979e501cb0e36_5aed315aea';

export interface NewsletterFields {
  email: string;
  firstName: string;
  lastName: string;
  honeypot: string;
}

export interface NewsletterResult {
  ok: boolean;
  message: string;
}

function readableMessage(msg: string): string {
  const text = msg.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
  return text.replace(/^\d+\s*-\s*/, '');
}

export function subscribeToNewsletter(fields: NewsletterFields): Promise<NewsletterResult> {
  if (fields.honeypot.trim()) {
    return Promise.resolve({ ok: true, message: 'Thanks for subscribing.' });
  }

  const params = new URLSearchParams({
    EMAIL: fields.email.trim(),
    FNAME: fields.firstName.trim(),
    LNAME: fields.lastName.trim(),
    [NEWSLETTER_HONEYPOT_FIELD]: '',
  });
  const callback = `mc${Date.now()}${Math.floor(Math.random() * 1000)}`;

  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    const timer = window.setTimeout(() => {
      cleanup();
      reject(new Error('The newsletter service did not respond. Try again.'));
    }, 12000);

    const cleanup = () => {
      window.clearTimeout(timer);
      script.remove();
      delete (window as unknown as Record<string, unknown>)[callback];
    };

    (window as unknown as Record<string, (data: { result?: string; msg?: string }) => void>)[callback] =
      (data) => {
        cleanup();
        const message = readableMessage(data.msg || '');
        resolve({
          ok: data.result === 'success',
          message: message || (data.result === 'success' ? 'Thanks for subscribing.' : 'Subscription failed.'),
        });
      };

    script.onerror = () => {
      cleanup();
      reject(new Error('The newsletter service did not respond. Try again.'));
    };
    script.src = `${MAILCHIMP_POST_JSON}&${params.toString()}&c=${callback}`;
    document.body.appendChild(script);
  });
}
